import { getAuthCookie } from '@/lib/utils/shared/cookies/getAuthCookie'
import useGlobalStore from '@/store/useGlobalStore'
import { useEffect } from 'react'
import { useSignOutUser } from './useSignOutUser'

export const useRefreshLoginState = () => {
  const {
    user: { customer, isSignedIn },
  } = useGlobalStore()
  const { signOutUser } = useSignOutUser()

  useEffect(() => {
    const checkAuthCookie = async () => {
      try {
        const authCookie = getAuthCookie()

        if (!authCookie && isSignedIn) {
          await signOutUser()
          return
        }

        if (!authCookie && customer) {
          await signOutUser()
        }
      } catch {
        await signOutUser()
      }
    }

    checkAuthCookie().catch(() => {})
  }, [customer, isSignedIn, signOutUser])

  useEffect(() => {
    ;(async () => {
      try {
        const authCookie = getAuthCookie()

        if (authCookie) {
          // make refresh token call here
          // if customer.href, customer data exists,
          // clear all customer data if no login token
          // we don't currently have a refresh token call
        } else if (customer) {
          await signOutUser()
        }
      } catch {
        await signOutUser()
      }
    })().catch(() => {})
  }, [customer, signOutUser])
}
